import React from "react";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router";
import { Images } from "../../../Assets/0a-exporter";
import "./job-posted-card.style.scss";
const JobPostedCard = ({ job }) => {
  const handleViewJob = (id) => {
    localStorage.setItem("job_id", id);
  };

  return (
    <div className="job-posted-card-main">
      <div className="jpcm-header">
        <div>
          <img src={Images.menTree} />
        </div>
        <div>
          <button>published</button>
          <button>PROMOTED</button>
        </div>
      </div>

      <h5 className="job-title">{job?.job_title}</h5>
      <p className="institute-name">{job?.institution_name}</p>
      <div className="jpcm-info">
        <span>
          <img src={Images.blueBook} />
          {job?.job_curiculum}
        </span>
        <span>
          <img src={Images.groupLogo} />
          {job?.job_class}
        </span>
        <span>
          <img src={Images.suitcaseLogo} />
          {job?.job_type}
        </span>
        <span>
          <img src={Images.manWIthStars} />
          {job?.job_experience} Exp
        </span>
        <span>
          <img src={Images.moneyLogo} />
          {job?.job_salary_range !== undefined &&
            job.job_salary_range
              .replace(/[^a-zA-Z0-9]/g, "-")
              .substring(
                1,
                job.job_salary_range.replace(/[^a-zA-Z0-9]/g, "-").length - 1
              )}
        </span>
      </div>
      <button className="apply-button">
        <Link
          to="/institute/job/appointments"
          onClick={() => handleViewJob(job?._id)}
        >
          View Applicants (22)
        </Link>
      </button>
      <button className="view-button">
        <Link
          to="/institute/job/description"
          onClick={() => handleViewJob(job?._id)}
        >
          View Job Details
        </Link>
      </button>
    </div>
  );
};
export default JobPostedCard;
